import { createService } from '@bonanza-social/toolkit/api';
import { CategoriesResponseSchema } from '../shared/categories.schemas';

export default {
  ...createService(
    {
      getCategories: {
        method: 'GET',
        url: '/lobby/categories',
        headers: {
          'x-api-version': '2',
          'x-feature-custom-themes-enabled': true,
        },
        responseSchema: CategoriesResponseSchema,
      },
    },
    ({ userId }) => `/Players/${userId}`,
  ),
  ...createService({
    getPublicCategories: {
      method: 'GET',
      url: '/lobby/categories',
      headers: {
        'x-api-version': '2',
        'x-feature-custom-themes-enabled': true,
      },
      public: true,
      responseSchema: CategoriesResponseSchema,
    },
  }),
};
